// /**
//  * Upselling & Packaging Logik im Shopify Cart
//  */
// document.addEventListener('DOMContentLoaded', () => {
//     attachCartEventListeners();
//     fetchAndHandleCart();
//   });
  
//   function attachCartEventListeners() {
//     ['onItemDeleted', 'onQuantityChange'].forEach(eventName => {
//       document.addEventListener(eventName, fetchAndHandleCart);
//     });
//   }
  
//   function fetchAndHandleCart() {
//     fetch('/cart.js', {
//       method: 'GET',
//       headers: { 'Content-Type': 'application/json' }
//     })
//       .then(res => res.json())
//       .then(handleCartLoad)
//       .catch(console.error);
//   }
  
//   function handleCartLoad(cart) {
//     const settings = getUpsellingSettings();
//     const packagingOptions = settings.packagingOptions || [];
//     const packagingLimit = settings.general?.packaging_options_products_limit || Infinity;
//     const upsellingLimit = settings.general?.upselling_limit || Infinity;
//     const upsellingEnabled = settings.general?.upselling_enabled;
  
//     const packagingSelector = document.querySelector("packaging-options-selector");
//     const upsellingSection = document.querySelector('.upselling[data-section-upselling]');
//     const checkoutButton = document.querySelector(".cart__checkout-button");
  
//     const cartItemsCount = getValidCartItemCount(cart.items, packagingOptions);
  
//     if (cart.items.length) checkoutButton?.removeAttribute("disabled");
  
//     validateLineItemsRelatedCover(cart.items);
  
//     // Upselling Sichtbarkeit
//     if (upsellingEnabled) {
//       upsellingSection?.classList.toggle('hidden', cartItemsCount > upsellingLimit);
//     }
  
//     // Geschenkoptionen Sichtbarkeit
//     if (cartItemsCount && cartItemsCount <= packagingLimit) {
//       packagingSelector?.removeAttribute("hidden");
//     }
  
//     const { singleCollection, multiCollection } = splitPackagingCollections(packagingOptions);
  
//     const cartHasPackagingItem = cart.items.some(item =>
//       packagingOptions.some(opt => item.id === opt.variantId)
//     );
  
//     const cartSinglePackagingItems = cart.items.filter(item =>
//       singleCollection.some(opt => item.id === opt.variantId)
//     );
  
//     const cartMultiPackagingItems = cart.items.filter(item =>
//       multiCollection.some(opt => item.id === opt.variantId)
//     );
  
//     if (cartHasPackagingItem) {
//       if (cartItemsCount === 1 && cartSinglePackagingItems.length) {
//         disableQuantityInputs(cartSinglePackagingItems);
//       }
  
//       const shouldRemovePackaging =
//         (cartItemsCount === 1 && cartMultiPackagingItems.length) ||
//         (cartItemsCount > 1 && cartSinglePackagingItems.length) ||
//         cartItemsCount === 0 ||
//         (upsellingEnabled && cartItemsCount > upsellingLimit);
  
//       if (shouldRemovePackaging) {
//         handleInvalidCart(packagingOptions.map(p => p.variantId));
//       }
//     }
//   }
  
//   function getValidCartItemCount(items, packagingOptions) {
//     return items.filter(item =>
//       item.properties._is_related_cover !== "true" &&
//       !item.product_type.includes("PPLR_HIDDEN_PRODUCT") &&
//       !packagingOptions.some(opt => item.id === opt.variantId)
//     ).reduce((sum, item) => sum + item.quantity, 0);
//   }
  
//   function disableQuantityInputs(items) {
//     items.forEach(item => {
//       const input = document.querySelector(`.quantity__input[data-variant-id="${item.id}"]`);
//       if (input) {
//         input.disabled = true;
//         ['plus', 'minus'].forEach(name => {
//           const btn = input.parentElement.querySelector(`button[name="${name}"]`);
//           if (btn) {
//             btn.disabled = true;
//             btn.classList.add("disabled");
//           }
//         });
//       }
//     });
//   }
  
//   function handleInvalidCart(variantIds) {
//     const updates = {};
//     variantIds.forEach(id => updates[id] = 0);
//     updateCart({ updates });
//   }
  
//   function updateCart(data) {
//     fetch('/cart/update.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data)
//     })
//       .then(res => res.json())
//       .then(() => setTimeout(() => window.location.reload(), 300))
//       .catch(console.error);
//   }
  
//   function addToCart(variantId, quantity, properties = null) {
//     const payload = { id: variantId, quantity };
//     if (properties) payload.properties = properties;
  
//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(payload)
//     })
//       .then(res => res.json())
//       .then(() => setTimeout(() => window.location.reload(), 300))
//       .catch(console.error);
//   }
  
//   function validateLineItemsRelatedCover(items) {
//     items.forEach(item => {
//       const relatedId = Number(item.properties?._related_cover || 0);
//       const relatedServiceId = Number(item.properties?._related_servicefee || 0);
//       const parentKey = item.key;

//       // Entscheide, was aktiv ist (Motiv oder Servicegebühr)
//       const active = relatedId || relatedServiceId;
//       if (!active) return;

//       const flag = relatedId ? "_is_related_cover" : "_is_related_servicefee";
//       const typeId = relatedId || relatedServiceId;

//       const alreadyInCart = items.some(i =>
//         i.id === typeId &&
//         i.properties?.[flag] === "true" &&
//         i.properties?._parent_key === parentKey
//       );

//       if (!alreadyInCart) {
//         addToCart(typeId, item.quantity, {
//           [flag]: "true",
//           _parent_key: parentKey
//         });
//       }
//     });
//   }
  
//   function splitPackagingCollections(options) {
//     return {
//       singleCollection: options.filter(o => o.collectionHandle === "geschenkoption-einzelversand"),
//       multiCollection: options.filter(o => o.collectionHandle === "geschenkoption-massenversand")
//     };
//   }
  
//   function getUpsellingSettings() {
//     const el = document.querySelector('[data-upselling-settings]');
//     try {
//       return JSON.parse(el?.textContent || "{}");
//     } catch {
//       return {};
//     }
//   }
  

/**
 * Upselling & Packaging Logik im Shopify Cart
 */
const EXCLUDED_GIFT_PRODUCT_HANDLES = [
  'decathlon',
  'h-m',
  'shop-apotheke',
  'adidas',
  'tk-maxx',
  'home24-gutschein',
  'rituals-gutschein',
  'butlers-gutschein'
];
document.addEventListener('DOMContentLoaded', () => {
    attachCartEventListeners();
    fetchAndHandleCart();
  });

  function isPackagingItem(item, packagingOptions) {
  return packagingOptions.some(opt => item.id === opt.variantId);
  }

  function isEnvelopeItem(item) {
    return item.handle === "geschenkumschlag" || item.product_handle === "geschenkumschlag";
  }

  function markRemovalNotices(updates, cart, packagingOptions) {
    const changedItems = Object.keys(updates)
      .map(key => cart.items.find(item => item.key === key))
      .filter(Boolean);

    const hasAddonRemoval = changedItems.some(item =>
      isPackagingItem(item, packagingOptions) && !isEnvelopeItem(item)
    );

    const hasEnvelopeRemoval = changedItems.some(item =>
      isEnvelopeItem(item)
    );

    if (hasAddonRemoval) {
      localStorage.setItem("addonNotice", "true");
    }

    if (hasEnvelopeRemoval) {
      localStorage.setItem("envelopeNotice", "true");
    }
  }

  function isPdfItem(item) {
    const handle = (item.handle || item.product_handle || "").toLowerCase();
    return handle.includes("pdf");
  }

  function isDigitalItem(item) {
    const handle = (item.handle || item.product_handle || "").toLowerCase();
    return handle.includes("digital");
  }
  
  function attachCartEventListeners() {
    ['onItemDeleted', 'onQuantityChange'].forEach(eventName => {
      document.addEventListener(eventName, fetchAndHandleCart);
    });
  }
  
  function fetchAndHandleCart() {
    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(res => res.json())
      .then(handleCartLoad)
      .catch(console.error);
  }
  
  function handleCartLoad(cart) {
    const settings = getUpsellingSettings();
    const packagingOptions = settings.packagingOptions || [];
    const packagingLimit = settings.general?.packaging_options_products_limit || Infinity;
    const upsellingLimit = settings.general?.upselling_limit || Infinity;
    const upsellingEnabled = settings.general?.upselling_enabled;
  
    const packagingSelector = document.querySelector("packaging-options-selector");
    const upsellingSection = document.querySelector('.upselling[data-section-upselling]');
    const checkoutButton = document.querySelector(".cart__checkout-button");
  
    const cartItemsCount = getValidCartItemCount(cart.items, packagingOptions);
  
    if (cart.items.length) checkoutButton?.removeAttribute("disabled");
  
    validateLineItemsRelatedCover(cart.items);
  
    // Upselling Sichtbarkeit
    if (upsellingEnabled) {
      upsellingSection?.classList.toggle('hidden', cartItemsCount > upsellingLimit);
    }
  
    // Geschenkoptionen Sichtbarkeit
    if (cartItemsCount && cartItemsCount <= packagingLimit) {
      packagingSelector?.removeAttribute("hidden");
    }
  
    const { singleCollection, multiCollection } = splitPackagingCollections(packagingOptions);
  
    const cartHasPackagingItem = cart.items.some(item =>
      packagingOptions.some(opt => item.id === opt.variantId)
    );
  
    const cartSinglePackagingItems = cart.items.filter(item =>
      singleCollection.some(opt => item.id === opt.variantId)
    );
  
    const cartMultiPackagingItems = cart.items.filter(item =>
      multiCollection.some(opt => item.id === opt.variantId)
    );
  
    if (cartHasPackagingItem) {
      if (cartItemsCount === 1 && cartSinglePackagingItems.length) {
        disableQuantityInputs(cartSinglePackagingItems);
      }

  const hasDigitalOrPdfVoucher = cart.items.some(item =>
    isPdfItem(item) || isDigitalItem(item)
  );

  const hasPhysicalVoucher = cart.items.some(item =>
    // Kein PDF, kein digitaler Artikel
    !isPdfItem(item) &&
    !isDigitalItem(item) &&
    // Ausschlüsse
    item.properties._is_related_cover !== "true" &&
    !item.product_type?.includes("PPLR_HIDDEN_PRODUCT") &&
    !packagingOptions.some(opt => item.id === opt.variantId) &&
    item.handle !== "geschenkumschlag" &&
    item.product_handle !== "geschenkumschlag"
  );

  // Wenn NUR digitale oder PDF-Gutscheine im Warenkorb sind → Add-ons entfernen
  if (hasDigitalOrPdfVoucher && !hasPhysicalVoucher) {
    const updates = {};
    const addonItems = cart.items.filter(item =>
      packagingOptions.some(opt => item.id === opt.variantId)
    );

    if (addonItems.length > 0) {
      addonItems.forEach(addon => updates[addon.key] = 0);
      markRemovalNotices(updates, cart, packagingOptions);
      updateCart({ updates });
      return;
    }
  }

  /* --- NEUE REGEL: bestimmte Artikel (z.B. decathlon) dürfen nicht mit Zusatzgeschenken kombiniert werden --- */
  const hasExcludedGiftProduct = cart.items.some(item =>
    EXCLUDED_GIFT_PRODUCT_HANDLES.includes(item.handle) ||
    EXCLUDED_GIFT_PRODUCT_HANDLES.includes(item.product_handle)
  );

  // Produkte, bei denen Add-ons erlaubt sind (quasi "physische" Standardartikel)
  const hasGiftEligibleProduct = cart.items.some(item =>
    !isPdfItem(item) &&
    !isDigitalItem(item) &&
    item.properties._is_related_cover !== "true" &&
    !item.product_type?.includes("PPLR_HIDDEN_PRODUCT") &&
    !packagingOptions.some(opt => item.id === opt.variantId) &&
    item.handle !== "geschenkumschlag" &&
    item.product_handle !== "geschenkumschlag" &&
    !EXCLUDED_GIFT_PRODUCT_HANDLES.includes(item.handle) &&
    !EXCLUDED_GIFT_PRODUCT_HANDLES.includes(item.product_handle)
  );

  // Wenn NUR ausgeschlossene Artikel (z.B. decathlon) + Add-ons im Warenkorb sind → Add-ons entfernen
  if (hasExcludedGiftProduct && !hasGiftEligibleProduct) {
    const updates = {};
    const addonItems = cart.items.filter(item =>
      packagingOptions.some(opt => item.id === opt.variantId)
    );

    if (addonItems.length > 0) {
      addonItems.forEach(addon => updates[addon.key] = 0);
      markRemovalNotices(updates, cart, packagingOptions);
      updateCart({ updates });
      return;
    }
  }
    const updates = {};

    if (cartHasPackagingItem) {
      if (cartItemsCount === 1 && cartSinglePackagingItems.length) {
        disableQuantityInputs(cartSinglePackagingItems);
      }

      /* --- Automatische Reduktion von Packaging-Optionen --- */

  const packagingItems = cart.items.filter(item =>
    packagingOptions.some(opt => item.id === opt.variantId)
  );

  // 🔓 Ausnahme
  const giftBoxItems = packagingItems.filter(item =>
    item.handle === "geschenkbox" || item.product_handle === "geschenkbox"
  );

  // ❗ alle anderen Add-ons (alte Logik!)
  const normalPackagingItems = packagingItems.filter(item =>
    item.handle !== "geschenkbox" && item.product_handle !== "geschenkbox"
  );

  const normalPackagingCount = normalPackagingItems.reduce((sum, item) => sum + item.quantity, 0);
  const giftBoxCount = giftBoxItems.reduce((sum, item) => sum + item.quantity, 0);

  // Nur physische Gutscheine zählen
  const standardCount = cart.items
    .filter(item =>
      !isPdfItem(item) &&
      !isDigitalItem(item) &&
      item.properties._is_related_cover !== "true" &&
      !item.product_type?.includes("PPLR_HIDDEN_PRODUCT") &&
      !packagingOptions.some(opt => item.id === opt.variantId) &&
      item.handle !== "geschenkumschlag" &&
      item.product_handle !== "geschenkumschlag" &&
      !EXCLUDED_GIFT_PRODUCT_HANDLES.includes(item.handle) &&
      !EXCLUDED_GIFT_PRODUCT_HANDLES.includes(item.product_handle)
    )
    .reduce((sum, item) => sum + item.quantity, 0);

  // ✅ ALTE LOGIK: alle normalen Add-ons 1:1
  if (normalPackagingCount > standardCount) {
    let excess = normalPackagingCount - standardCount;

    for (const item of normalPackagingItems) {
      if (excess <= 0) break;

      if (item.quantity <= excess) {
        updates[item.key] = 0;
        excess -= item.quantity;
      } else {
        updates[item.key] = item.quantity - excess;
        excess = 0;
      }
    }

    localStorage.setItem('addonNotice', 'true');
  }

  const giftBoxLimit = standardCount > 0 ? standardCount + 9 : 0;

  if (giftBoxCount > giftBoxLimit) {
    let excess = giftBoxCount - giftBoxLimit;

    for (const item of giftBoxItems) {
      if (excess <= 0) break;

      if (item.quantity <= excess) {
        updates[item.key] = 0;
        excess -= item.quantity;
      } else {
        updates[item.key] = item.quantity - excess;
        excess = 0;
      }
    }

    localStorage.setItem('addonNotice', 'true');
  }
  
/* --- AUSKOMMENTIERT: automatische Entfernung von Packaging-Optionen ---
      const shouldRemovePackaging =
        (cartItemsCount === 1 && cartMultiPackagingItems.length) ||
        (cartItemsCount > 1 && cartSinglePackagingItems.length) ||
        cartItemsCount === 0 ||
        (upsellingEnabled && cartItemsCount > upsellingLimit);
  
      if (shouldRemovePackaging) {
        handleInvalidCart(packagingOptions.map(p => p.variantId));
      }
      --- ENDE AUSKOMMENTIERT --- */ 
    }

  /* --- NEUE REGEL: "geschenkumschlag" nur mit genau 1 Gutschein --- */
  const envelopeLine = cart.items.find(item =>
    item.handle === "geschenkumschlag" || item.product_handle === "geschenkumschlag"
  );

  if (envelopeLine) {
    const voucherCount = cart.items
      .filter(item =>
        item.properties._is_related_cover !== "true" &&
        !item.product_type.includes("PPLR_HIDDEN_PRODUCT") &&
        !packagingOptions.some(opt => item.id === opt.variantId) &&
        item.handle !== "geschenkumschlag" && item.product_handle !== "geschenkumschlag"
      )
      .reduce((sum, item) => sum + item.quantity, 0);

    if (voucherCount > 1) {
      updates[envelopeLine.key] = 0;
      localStorage.setItem("envelopeNotice", "true");
    }
  }

  /* --- NUR EIN Aufruf am Ende --- */
  if (Object.keys(updates).length > 0) {
    const removedOrReducedAddon = Object.keys(updates).some(key => {
      const item = cart.items.find(cartItem => cartItem.key === key);

      return item && packagingOptions.some(opt => item.id === opt.variantId);
    });

    if (removedOrReducedAddon) {
      localStorage.setItem("addonNotice", "true");
    }

    updateCart({ updates });
  }
  
  let digitalExperienceCount = 0;
  const digitalExperienceItems = [];

  cart.items.forEach((element, index) => {
    if (element.properties['Thumbnail-Image']) {
      digitalExperienceCount += 1;
      digitalExperienceItems.push({ element: element, index: index });
    }
  });

  if (digitalExperienceCount > 0) {
    digitalExperienceItems.forEach(element => {
      onlyDisableQuantityInputs(element.index, element.element, digitalExperienceCount);
    });
  }
  }
  }
  
  function getValidCartItemCount(items, packagingOptions) {
    return items.filter(item =>
      item.properties._is_related_cover !== "true" &&
      !item.product_type.includes("PPLR_HIDDEN_PRODUCT") &&
      !packagingOptions.some(opt => item.id === opt.variantId)
    ).reduce((sum, item) => sum + item.quantity, 0);
  }
  
  function disableQuantityInputs(items) {
    items
      // 1) Geschenkbox rausfiltern
      .filter(item =>
        item.handle !== "geschenkbox" &&
        item.product_handle !== "geschenkbox"
      )
      .forEach(item => {
        const input = document.querySelector(`.quantity__input[data-variant-id="${item.id}"]`);
        // 2) Guard, falls kein Input gefunden wird
        if (!input) return;

        input.disabled = true;

        ['plus', 'minus'].forEach(name => {
          const btn = input.parentElement.querySelector(`button[name="${name}"]`);
          if (btn) {
            btn.disabled = true;
            btn.classList.add("disabled");
          }
        });
      });
  }
  function onlyDisableQuantityInputs(index, item, digitalExperienceCount) {
    const input = document.querySelector(`tr[data-voucher-id="${item.properties['Produkt-ID']}"] input`);
    if (!input) return;
    input.disabled = true;
    const btn = input.parentElement.querySelector(`button[name="minus"]`);
    if (btn && digitalExperienceCount > 1) {
      btn.disabled = false;
      btn.classList.remove("disabled");
      btn.addEventListener('click', () => {
        removeItemFromCart(index);
      });
    }
  }

  function removeItemFromCart(index) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: index + 1, quantity: 0 })
    })
    .then(res => res.json())
    .then(() => setTimeout(() => window.location.reload(), 300))
    .catch(console.error);
  }

  function handleInvalidCart(variantIds) {
    const updates = {};
    variantIds.forEach(id => updates[id] = 0);
    updateCart({ updates });
  }
  
  function updateCart(data) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(() => setTimeout(() => window.location.reload(), 300))
      .catch(console.error);
  }
  
  function addToCart(variantId, quantity, properties = null) {
    const payload = { id: variantId, quantity };
    if (properties) payload.properties = properties;
  
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(() => setTimeout(() => window.location.reload(), 300))
      .catch(console.error);
  }
  
  function validateLineItemsRelatedCover(items) {
  const updates = {};

  items.forEach(item => {
    const relatedId = Number(item.properties?._related_cover || 0);
    const relatedServiceId = Number(item.properties?._related_servicefee || 0);
    const parentKey = item.key;

    // Entscheide, was aktiv ist (Motiv oder Servicegebühr)
    const active = relatedId || relatedServiceId;
    if (!active) return;

    const flag = relatedId ? "_is_related_cover" : "_is_related_servicefee";
    const typeId = relatedId || relatedServiceId;

    const existingRelated = items.find(i =>
      i.id === typeId &&
      i.properties?.[flag] === "true" &&
      i.properties?._parent_key === parentKey
    );

    if (!existingRelated) {
      addToCart(typeId, item.quantity, {
        [flag]: "true",
        _parent_key: parentKey
      });
    } else if (existingRelated.quantity !== item.quantity) {
      updates[existingRelated.key] = item.quantity;
    }
  });

  if (Object.keys(updates).length > 0) {
    markRemovalNotices(updates, cart, packagingOptions);
    updateCart({ updates });
  }
}
  
  function splitPackagingCollections(options) {
    return {
      singleCollection: options.filter(o => o.collectionHandle === "geschenkoption-einzelversand"),
      multiCollection: options.filter(o => o.collectionHandle === "geschenkoption-massenversand")
    };
  }
  
  function getUpsellingSettings() {
    const el = document.querySelector('[data-upselling-settings]');
    try {
      return JSON.parse(el?.textContent || "{}");
    } catch {
      return {};
    }
  }
  